import { render, staticRenderFns } from "./UserSelectionMulti.vue?vue&type=template&id=327be237&scoped=true"
import script from "./UserSelectionMulti.vue?vue&type=script&lang=js"
export * from "./UserSelectionMulti.vue?vue&type=script&lang=js"
import style0 from "./UserSelectionMulti.vue?vue&type=style&index=0&id=327be237&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327be237",
  null
  
)

export default component.exports